// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/text-align-end.js';

import { paths } from '../generated/text-align-end';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('text-align-end', Original, paths);
